import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

const LCPhoneService = {
  skipLocation3dsVerification: (locationId: string) =>
    requests(SERVICE_NAME.LC_PHONE_API).put(
      `twilio-accounts/skip-3ds?locationId=${locationId}&activate=true`
    ),
  increaseCallerIdVerificationLimit: (locationId: string) =>
    requests(SERVICE_NAME.LC_PHONE_API).put(
      `twilio-accounts/caller-id-verification-limit?locationId=${locationId}`
    ),
  cleanUpTwilio(locationId: string, agencyId: string, cleanUpType: string) {
    return requests(SERVICE_NAME.LC_PHONE_API)
      .log({
        module: Module.ISV,
        entityType: EntityType.LOCATION,
        entityId: locationId,
        documentId: locationId,
      })
      .post(`twilio-accounts/cleanupTwilio`, {
        locationId,
        agencyId,
        cleanUpType,
        source: "internal-tools",
      });
  },
};

export default LCPhoneService;
